// extracted by mini-css-extract-plugin
module.exports = {"title":"dnUSXWxn","input":"r1LHouRR","searchButton":"_1TJGp1Iy"};